/** True when a signup option has a non-zero price to display. */
export function hasSignupPrice(price: number | string | null | undefined): boolean {
  return Number(price) > 0;
}

export function formatSignupPrice(price: number | string): string {
  return `$${Number(price).toFixed(2)}`;
}

/** Apply page path with an optional pre-selected registration option. */
export function buildEventApplyPath(
  eventSlug: string,
  optionId?: string | null
): string {
  const base = `/events/${encodeURIComponent(eventSlug)}/apply`;
  if (!optionId) return base;
  return `${base}?option=${encodeURIComponent(optionId)}`;
}
